import { useCallback, useEffect, useState } from "react";
import { getSurveyDetail } from "../api/survey.api";
import type { SurveyAdminDetailResponse } from "../types/survey.types";
import { normalizeSurveyQuestions } from "../utils/survey.utils";

export const useGetSurveyDetail = (id?: string) => {
  const [survey, setSurvey] = useState<SurveyAdminDetailResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSurveyDetail = useCallback(async () => {
    if (!id) return null;

    try {
      setLoading(true);
      setError(null);
      const surveyData = await getSurveyDetail(id);
      const normalizedSurvey = {
        ...surveyData,
        questions: normalizeSurveyQuestions(surveyData.questions),
      };
      setSurvey(normalizedSurvey);
      return normalizedSurvey;
    } catch (fetchError: any) {
      console.error("Failed to fetch survey detail:", fetchError);
      const errorMessage =
        fetchError.response?.data?.user_message ||
        fetchError.response?.data?.message ||
        fetchError.message ||
        "Failed to load survey details";
      setError(errorMessage);
      setSurvey(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    void fetchSurveyDetail();
  }, [fetchSurveyDetail]);

  return { survey, loading, error, refresh: fetchSurveyDetail };
};
